module.exports = __webpack_public_path__ + "static/media/49850022-8jT0wSgs.d2a6b5df.JPG";